import React from 'react'
import { Grid } from '@material-ui/core'
import { FormattedMessage } from 'react-intl'
import LiquidCheckbox from '@src/components/LiquidCheckbox'
import useFormikHelper from '../useFormikHelper'
import { useProductFromQueryParam } from '../ProductsConfiguration'
import { BiTubeProduct } from '../../BiTube/enum'

interface AutoGenerateProps {
  autoGenerateName: (e: string) => void
  autoGenerateSequence: (e: string, b: string) => void
  disabled: boolean
}
const AutoGenerate: React.FC<AutoGenerateProps> = ({
  autoGenerateName,
  autoGenerateSequence,
  disabled,
}) => {
  const formik = useFormikHelper()
  const product = useProductFromQueryParam()

  const generateName = async (e: React.ChangeEvent<HTMLInputElement>) => {
    formik.setOligoFieldValue('senseNameCheck', e.target.checked, false)
    const nameField = product === BiTubeProduct.mirna ? 'antisenceName' : 'name'
    e.target.checked &&
      autoGenerateName(formik.selectedOligoValues?.[nameField] || '')
    if (e.target.checked) {
      formik.setFieldError(nameField, '')
    }
  }

  const generateSequence = async (e: React.ChangeEvent<HTMLInputElement>) => {
    formik.setOligoFieldValue('autoGenerateOligo', e.target.checked, false)
    e.target.checked &&
      autoGenerateSequence(
        formik.selectedOligoValues?.sequence || '',
        formik.selectedOligoValues?.customerOverhang || ''
      )
  }

  return (
    <Grid item xs={12}>
      <Grid container spacing={3}>
        <Grid item>
          <LiquidCheckbox
            checked={!!formik.selectedOligoValues?.senseNameCheck}
            onChange={generateName}
            label={
              product !== BiTubeProduct.mirna ? (
                <FormattedMessage
                  id="CONF_AUTOGEN_NAME"
                  defaultMessage="Use Sense Name"
                />
              ) : (
                <FormattedMessage
                  id="CONF_MIRNA_USE_ANTISENCE_NAME"
                  defaultMessage="Use Antisense Name"
                />
              )
            }
            disabled={disabled}
          />
        </Grid>
        {product !== BiTubeProduct.mirna && (
          <Grid item>
            <LiquidCheckbox
              checked={!!formik.selectedOligoValues?.autoGenerateOligo}
              onChange={generateSequence}
              label={
                <FormattedMessage
                  id="CONF_AUTOGEN_SEQUENCE"
                  defaultMessage="Auto-Generate Antisense Oligo"
                />
              }
              disabled={disabled}
            />
          </Grid>
        )}
      </Grid>
    </Grid>
  )
}

export default AutoGenerate
